import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { navStore } from '@mcn-platform/models';
const GlobalConfirmDialog = () => {
    const { confirmDialog } = navStore;
    const handleConfirm = () => {
        confirmDialog.confirm();
    };
    const handleCancel = () => {
        confirmDialog.cancel();
    };
    const handleDialogClose = (_event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown')
            return;
        handleCancel();
    };
    return (_jsxs(Dialog, { open: confirmDialog.open, onClose: handleDialogClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [_jsx(DialogTitle, { id: "alert-dialog-title", children: confirmDialog.title }), _jsx(DialogContent, { children: _jsx(DialogContentText, { id: "alert-dialog-description", children: confirmDialog.message }) }), _jsxs(DialogActions, { children: [confirmDialog.cancelButtonLabel && (_jsx(Button, { "data-testid": "cancelButton", onClick: handleCancel, autoFocus: true, children: confirmDialog.cancelButtonLabel })), _jsx(Button, { "data-testid": "confirmButton", onClick: () => handleConfirm(), children: confirmDialog.confirmButtonLabel })] })] }));
};
export default observer(GlobalConfirmDialog);
//# sourceMappingURL=GlobalConfirmDialog.js.map